import React from 'react';
import styled from 'styled-components';
import FunnelChart from './FunnelChart';
import RetentionChart from './RetentionChart';

const DetailBlock = styled.div`
  width: 100%;
`;

const SectionTitle = styled.div`
  width: 100%;
  text-align: center;
  font-size: 24px;
  padding-top: 10px;
  font-family: AvenirNext-DemiBold;
  background-color: #eee;
  padding-bottom: 10px;
`;

const Column = styled.td`
  display: flex;
  flex-direction: column;
  border-right: 1px solid #ccc;
`;

const SolutionLink = styled.div`
  border: 1px solid #eee;
  min-width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  font-size: 20px;
  height: 50px;
  text-align: center;
  border-radius: 5px;
  align-self: center;
`;

const FunnelSegment = ({
  section,
  dateSetting
}) => {
  let dateText = 'This week';
  if (dateSetting === 'months') { dateText = 'Last 30 days'; }
  if (dateSetting === 'quarters') { dateText = 'Last 90 days'; }
  return (
    <Column>
      <DetailBlock>
        <SectionTitle>
          {section.title}
          <SolutionLink><a href={section.productSection} rel="noopener noreferrer" target="_blank">Product Roadmap</a></SolutionLink>
          <SolutionLink><a href={section.productSection} rel="noopener noreferrer" target="_blank">Sales Process</a></SolutionLink>
        </SectionTitle>
        {section.details.map((detail, index) => {
          if (detail.type === 'retention') {
            console.log(detail)
            return (
              <RetentionChart
                title={detail.title}
                data={detail.data}
                isPrimary={detail.isPrimary}
              />
            );
          }
          return (
            <FunnelChart
              title={detail.title}
              isMulti={detail.isMulti}
              values={detail.values}
              dateText={dateText}
              isPrimary={index === 0}
              isStacked={detail.isStacked}
              target={detail.target}
              upperBound={detail.upperBound}
              isBoilerplate={detail.isBoilerplate}
            />
          );
        })
        }
      </DetailBlock>
    </Column>
  );
}



export default FunnelSegment;